import * as types from './actionTypes'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
    email: 'admin@admin.com',
    password: 'aaaaaa',
    apiToken: '',
    loading: false,
    error: '',
})

export default function reduce(state = initialState, action = {}) {

    switch (action.type) {

        case types.EMAIL_SET:
            return state.merge({
                email: action.value,
            })

        case types.API_TOKEN_SET:
            return state.merge({
                apiToken: action.value,
            })

        case types.PASSWORD_SET:
            return state.merge({
                password: action.value,
            })

        case types.LOADING_SET:
            return state.merge({
                loading: action.value,
            })

        case types.ERROR_SET:
            return state.merge({
                error: action.value,
            })

        default:
            return state
    }
}

export function getLoading(state) {
    return state.adminLogin.loading
}

export function getEmail(state) {
    return state.adminLogin.email
}

export function getPassword(state) {
    return state.adminLogin.password
}

export function getToken(state) {
    return state.adminLogin.apiToken
}

export function getError(state) {
    return state.adminLogin.error
}
